import onReady from '../utils/onReady';
import * as Events from '../utils/events';
import * as formError from '../utils/formError';
import scrollTo from '../utils/scrollTo';


/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class FormValidate {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        // Put your other DOM-specific initializations here, and get your class moving!

        this.dom.buttonSubmit = this.dom.container.querySelector('.buttonSubmit');
        this.dom.requiredInputs = this.dom.container.querySelectorAll('[required]:not(.datepicker)');
        this.dom.emails = this.dom.container.querySelectorAll('[type=email]');
        this.dom.passwords = this.dom.container.querySelectorAll('.password-validate');
        this.dom.postalCode = this.dom.container.querySelector('#form-profile__postalcode');
        this.dom.errorInput = this.dom.container.querySelector('.input-validation-error');
        this.dom.paymentTermsAccepted = this.dom.container.querySelector("#PaymentTermsAccepted");

        if (this.dom.errorInput) {
            scrollTo(this.dom.errorInput, 500, [0, -40]);
        }

        this.addEvents();

    }

    addEvents() {
        Events.addEvent(this.dom.container, "submit", e => {
            e.preventDefault();
            this.submit();
        });
    }

    /**
     * Check if any required input fields are empty
     *
     * @return {Bool} True or false. True if issue found
     */
    emptyCheck() {
        for (let i = 0; i < this.dom.requiredInputs.length; i +=1 ) {
            if (!this.dom.requiredInputs[i].value.length) {
                this.dom.requiredInputs[i].placeholder = "Dette felt skal udfyldes";

                formError.addErrorClass(this.dom.requiredInputs[i], "Udfyld dette felt", "keydown");
                return true;
            }
        }

        return false;
    }

    /**
     * Check if postalcode is above 4 numbers
     *
     * @return {Bool} True or false. True if issue found
     */
    postalCodeCheck() {
        if (this.dom.postalCode) {

            if (this.dom.postalCode.value.length > 4) {
                formError.addErrorClass(this.dom.postalCode, "Postkoden må maks være på 4 cifre", "keydown");
                return true;
            }
        }

        return false;
    }

    /**
     * Check if e-mails are valid
     *
     * @return {boolean} True or false. True if issue found
     */
    emailCheck() {
        let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        for (let i = 0; i < this.dom.emails.length; i +=1 ) {
            if (!regex.test(this.dom.emails[i].value)) {

                formError.addErrorClass(this.dom.emails[i], "Indtast en valid email", "keydown");
                return true;
            }
        }

        return false;
    }

    /**
     * Check if e-mails are matching
     *
     * @return {boolean} True or false. True if issue found
     */
    emailCompare() {
        if (this.dom.emails.length > 1) {

            if (this.dom.emails[0].value !== this.dom.emails[1].value) {
                formError.addErrorClass(this.dom.emails[1], "Emails skal være ens", "keydown");
                return true;
            }
        }

        return false;
    }

    /**
     * Check if password fulfills requirements
     *
     * @return {boolean} True or false. True if issue found
     */
    passwordCheck() {
        let regex = /^(([A-Z0-9.,_])\2?(?!\2))([A-Z0-9.,_]){5,}$/i;

        for (let i = 0; i < this.dom.passwords.length; i +=1 ) {
            if (!regex.test(this.dom.passwords[i].value)) {
                formError.addErrorClass(this.dom.passwords[i], "Kodeord opfylder ikke krav", "keydown");
                return true;
            }
        }

        return false;
    }

    /**
     * Check if passwords are matching
     *
     * @return {boolean} True or false. True if issue found
     */
    passwordCompare() {
        if (this.dom.passwords.length > 1) {

            if (this.dom.passwords[0].value !== this.dom.passwords[1].value) {
                formError.addErrorClass(this.dom.passwords[1], "Kodeordene skal være ens", "keydown");
                return true;
            }
        }

        return false;
    }

    termsAccepted() {
        if (this.dom.paymentTermsAccepted) {
            if (!this.dom.paymentTermsAccepted.checked) {
                formError.addErrorClass(this.dom.paymentTermsAccepted.closest(".PaymentTermsAccepted"), "Du skal acceptere handelsbetingelserne", "change");
                return true;
            }
        }

        return false;
    }

    /**
     * If no checks are true, the form is submitted
     *
     */
    submit() {
        if (this.emptyCheck()) { return; } // Error handling is done in function
        else if(this.postalCodeCheck()) { return;} // Error handling is done in function
        else if(this.emailCheck()) { return;} // Error handling is done in function
        else if(this.emailCompare()) { return; }
        else if(this.termsAccepted()) { return; }
        // else if(this.passwordCheck()) { return; } // Error handling is done in function
        // else if(this.passwordCompare()) { return; } // Error handling is done in function
        else {
            this.dom.container.submit();
        }
    }
}


export default FormValidate;